<template>
  <div class="step-2-page">
    <div class="over-btn">
      <div class="header-block">
        <div class="insert-subject">
          {{ $t('heatmap.registration.subject') }} 2 / 2
        </div>

        <div class="tracking-code">
          <span>
          {{ $t('heatmap.registration.trackingCode') }}
          </span>
          <button class="code-check" @click="$emit('codeCheck', url)">
            <i class="icon icon--arrow-right-blue-xsmall"></i>
            <span>{{ $t('heatmap.registration.codeCheck') }}</span>
          </button>
        </div>

        <div class="url" ref="urlBox">
          {{ listUrl }}
        </div>
      </div>
      <div class="step2-body">
        <div class="login-check">
          <div class="login-check-description">
            <ui-icon-tooltip class="login-tooltip"
            :iconSize="'outline-white'"
            arrowLeftSide>
            <span v-html="$t('heatmap.registration.loginCheck.tooltip')"></span>
            </ui-icon-tooltip>
            {{ $t('heatmap.registration.loginCheck.description') }}
          </div>
          <div class="login-check-radios">
            <ui-radio :value="loginCheck"
                  @input="loginCheckChange(true)">
              {{ $t('common.yes') }}
            </ui-radio>
            <ui-radio :value="!loginCheck"
                  @input="loginCheckChange(false)">
              {{ $t('common.no') }}
            </ui-radio>
          </div>
        </div>
        <div class="url" v-if="!getLoginCheck">
          <ui-input-text :type="'text'"
                :modelValue="getUrl"
                :style="{'margin-top': '0px'}"
                :modelError="matchError"
                :placeholder="$t('heatmap.registration.urlCheck.placeholder')"
                :byteLimit="950"
                @input="inputUrl">
            {{ $t('heatmap.registration.urlCheck.label') }}
          </ui-input-text>
        </div>

        <div class="selector-exclude">
          <div class="selector-exclude-subject">
            <ui-icon-tooltip class="selector-tooltip"
            :iconSize="'outline-white'"
            arrowLeftSide>
            <span v-html="$t('heatmap.registration.tooltip.selector')"></span>
            </ui-icon-tooltip>
            {{ $t('heatmap.registration.exclude.subject') }}
          </div>
          <div class="selector-exclude-radios">
            <ui-radio :value="excludeCheck"
                  @input="excludeCheckChange(true)">
              {{ $t('common.yes') }}
            </ui-radio>
            <ui-radio :value="!excludeCheck"
                  @input="excludeCheckChange(false)">
              {{ $t('common.no') }}
            </ui-radio>
          </div>
        </div>
        <div v-if="excludeCheck" class="exclude-input-wrap">
          <div class="exclude-description" v-html="$t('heatmap.registration.exclude.description.first')">
          </div>
          <ui-input-text :type="'text'"
                :modelValue="getSelector"
                :style="{'margin-top': '5px'}"
                :placeholder="$t('heatmap.registration.exclude.placeholder')"
                :byteLimit="950"
                @input="inputSelector">
          </ui-input-text>
        </div>
      </div>
    </div>
    <div class="btn-wrap">
      <div v-if="isEditMode" class="back-btn-wrap-edit" :class="{'prev': !loginCheck}">
        <ui-button
          class="back-btn"
          :iconName="'icon--arrow-left-black'"
          :size="'large'"
          :style="{'margin-left': '245px', 'text-align': 'center'}"
          @click="backStep">
          {{ $t('common.prev') }}
        </ui-button>
      </div>
      <div v-else class="back-btn-wrap" :class="{'prev': !loginCheck}">
        <ui-button
          class="back-btn"
          :iconName="'icon--arrow-left-black'"
          :size="'large'"
          :style="{'margin-left': '245px', 'text-align': 'center'}"
          @click="backStep">
          {{ $t('common.prev') }}
        </ui-button>
      </div>
      <div class="reg-btn-wrap" :class="{'no-prev': loginCheck}">
        <ui-button v-if="!loginCheck"
          class="btn-confirm"
          :primary2="true"
          :buttonType="'submit'"
          :disabled="!isMatchedURL() || !registerExcludeCheck"
          @click="nextStep">
          {{ $t('common.preview') }}
        </ui-button>
        <div class="tooltip__wrap">
          <ui-button :iconName="'icon--check-white-size16'"
            class="btn-confirm"
            :style="{ 'margin-left': '5px' }"
            :buttonType="'submit'"
            :primary="true"
            :disabled="(!registerCheck && !isMatchedURL()) || !registerExcludeCheck"
            @click="register">
            {{ isEditMode ? $t('heatmap.registration.edit') : $t('common.register') }}
          </ui-button>
          <ui-tooltip class="preview-tooltip" :style="{'bottom': '43px', 'right': '-45px'}" v-show="(registerCheck || isMatchedURL()) && !getLoginCheck && registerExcludeCheck" arrowNone >
            <p v-html="$t('heatmap.registration.pass')"></p>
          </ui-tooltip>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import UiRadio from '@/components/ui/UiRadio'
import UiIconTooltip from '@/components/ui/UiIconTooltip'
import UiInputText from '@/components/ui/UiInputText'
import UiButton from '@/components/ui/UiButton'
import UiTooltip from '@/components/ui/UiTooltip'
import { mapState } from 'vuex'
import { CommonStorage } from '@/libs/auth-helper'
import { LOCALE_COOKIE } from '@/libs/constants'

export default {
  name: 'HeatmapRegistrationStep2',
  components: {
    UiRadio,
    UiButton,
    UiInputText,
    UiIconTooltip,
    UiTooltip
  },
  props: {
    url: {
      default: ''
    },
    listUrl: {
      default: ''
    },
    isEditMode: {
      default: false
    },
    model: {
      default: false
    },
    originUrl: {
      default: ''
    },
    gUrlId: {
      default: ''
    },
    jamCount: {
      default: 0
    }
  },
  data () {
    return {
      headerHeight: 0,
      matchError: '',
      loginCheck: !!(this.isEditMode && this.model.bLogin),
      excludeCheck: !!(this.isEditMode && this.model.exceptionSelector),
      inputUrlVal: '',
      lang: CommonStorage.getItem(LOCALE_COOKIE.name)
    }
  },
  created () {
  },
  computed: {
    ...mapState([
      'userData'
    ]),
    getSelector () {
      if (this.isEditMode && this.model.exceptionSelector) {
        this.inputSelector(this.model.exceptionSelector)
        return this.model.exceptionSelector
      } else {
        return ''
      }
    },
    getUrl () {
      if (this.isEditMode) {
        this.inputUrl(this.model.captureURL)
        return this.model.captureURL
      } else {
        const url = this.model.captureURL || this.originUrl
        this.inputUrl(url)
        return url
      }
    },
    getLoginCheck () {
      return this.loginCheck
    },
    getInputUrl () {
      return this.inputUrlVal
    },
    registerCheck () {
      let result = false
      if (this.loginCheck) {
        result = true
      } else {
        result = false
      }
      return result
    },
    registerExcludeCheck () {
      let result = false
      if (this.excludeCheck) {
        if (this.model.exceptionSelector) {
          result = true
        } else {
          result = false
        }
      } else {
        result = true
      }
      return result
    }
  },
  methods: {
    isMatchedURL () {
      let isMatchedURL = false
      if (this.inputUrlVal) {
        let parsedURL
        let parsedCaptureURL
        try {
          parsedURL = new URL(this.originUrl)
          parsedCaptureURL = new URL(this.inputUrlVal)
        } catch (e) {
          isMatchedURL = false
        }

        const pathname = parsedURL.pathname || ''
        isMatchedURL = parsedCaptureURL.pathname === pathname
      }
      if (!isMatchedURL) {
        this.matchError = 'diffFormatUrl'
      } else {
        this.matchError = ''
      }
      return isMatchedURL
    },
    nextStep () {
      this.setData()
      this.$emit('nextStep', this.model)
    },
    register () {
      this.setData()
      this.$emit('register', this.model)
    },
    setData () {
      if (!this.model.captureURL) {
        this.model.captureURL = decodeURIComponent(this.inputUrlVal)
      }
      this.model.bLogin = this.loginCheck
      if (this.loginCheck) {
        this.model.gUrlId = this.gUrlId
      }
      if (!this.excludeCheck) {
        this.model.exceptionSelector = ''
      }
      if (this.inputUrlVal) {
        const urlObj = new URL(this.inputUrlVal)
        this.model.domain = decodeURIComponent(urlObj.hostname)
        this.model.pathname = decodeURIComponent(urlObj.pathname)
      } else {
        if (this.isEditMode) {
          if (this.loginCheck) {
            delete this.model.domain
            delete this.model.pathname
          } else {
            const urlObj = new URL(this.inputUrlVal)
            this.model.domain = decodeURIComponent(urlObj.hostname)
            this.model.pathname = decodeURIComponent(urlObj.pathname)
          }
        }
      }
    },
    inputUrl (value) {
      this.inputUrlVal = value
      this.model.captureURL = decodeURIComponent(this.inputUrlVal)
    },
    inputSelector (value) {
      this.model.exceptionSelector = value
    },
    backStep () {
      this.$emit('backStep')
    },
    loginCheckChange (val) {
      this.model.bLogin = val
      if (val) {
        this.inputUrlVal = this.originUrl
      } else {
        if (this.isEditMode) {
          this.inputUrl(this.model.captureURL)
        }
      }
      this.loginCheck = val
    },
    excludeCheckChange (val) {
      this.excludeCheck = val
      if (this.excludeCheck) {
        this.model.exceptionSelector = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.step-2-page {
  height: inherit;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .over-btn {
    height: 100%;
    padding-bottom: 30px;
    padding-right: 27px;
    margin-bottom: 15px;
    width: 100%;
    overflow-y: auto;
    --scrollbar-width: 8px;
    --mask-height: 40px;
    --mask-image-content: linear-gradient(
        to bottom,
        black var(--mask-height),
        black calc(100% - var(--mask-height)),
        transparent
    );

    --mask-size-content: calc(100% - var(--scrollbar-width)) 100%;
    --mask-image-scrollbar: linear-gradient(black, black);
    --mask-size-scrollbar: var(--scrollbar-width) 100%;
    mask-image: var(--mask-image-content), var(--mask-image-scrollbar);
    mask-size: var(--mask-size-content), var(--mask-size-scrollbar);
    mask-position: 0 0, 100% 0;
    mask-repeat: no-repeat, no-repeat;

    .header-block {
      text-align: left;
      border-bottom: dashed 1px #c1c1c1;
      border-color: #c1c1c1;
      .insert-subject {
        color: #2F2F2F;
        margin-bottom: 5px;
        font-size: 15px;
        font-style: normal;
        font-weight: 500;
        line-height: 15px; /* 100% */
      }
      .tracking-code {
        & span {
          color: #767676;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          display: inline-block;
          margin-bottom: 23px;
        }

        .code-check {
          position: relative;
          margin-left: 8px;

          & .icon {
            position: absolute;
            top: 50%;
            transform: translate(0, -50%);
          }

          & span {
            position: relative;
            color: #0074FF;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px;
            margin: 0 0 0 15px;
          }
        }
      }
      .url {
        color: #767676;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 183.333% */
        margin-bottom: 10px;
        word-break: break-all;
      }
    }
    .step2-body {

      .login-check {
        display: flex;
        margin-top: 30px;
        justify-content: space-between;
        .login-check-description {
          text-align: left;
          color: #000;
          width: 325px;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px; /* 157.143% */

          .tooltip {
            margin-right: 8px;
          }

          &/deep/ .icon--info-outline-white {
            margin-left: 5px;
            margin-top: 2px;
          }
          &/deep/ .bubble {
            bottom: -30px;
            left: 28px;
            .text {
              text-align: left;
            }
          }
        }
        .login-check-radios {
          margin-top: 4px;
        }
      }
      .url {
        margin-top: 30px;
        .validation-text {
          font-size: 12px;
          font-weight: bold;
          color: $errorColor;
          padding-left: 6px;
        }
      }
      .selector-exclude {
        margin-top: 35px;
        display: flex;
        justify-content: space-between;
        .selector-exclude-subject {
          text-align: left;
          width: 325px;
          color: #000;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          .tooltip {
            margin-right: 8px;
          }

          &/deep/ .icon--info-outline-white {
            margin-left: 5px;
            margin-top: 2px;
          }
          &/deep/ .bubble {
            left: 27px;
            bottom: -20px;
            .text {
              text-align: left;
            }
          }
        }
        .selector-exclude-radios {
          text-align: right;
          margin-top: 4px;
        }
      }
      .exclude-input-wrap {
        margin-top: 8px;
        text-align: left;
        .exclude-description {
          color: #767676;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 19px;
          width: 360px;
        }
      }
    }
  }
  .btn-wrap {
    position: relative;
    display: flex;
    justify-content: space-between;
    left: 0;
    bottom: 0;
    .reg-btn-wrap {
      display: flex;
      &.no-prev {
        &::before {
          content: "";
          display: block;
          position: absolute;
          bottom: 8px;
          right: 130px;
          width: 1px;
          height: 24px;
          background-color: #a5a3a3;
        }
      }
      .tooltip__wrap {
        position: relative;
        display: flex;
        .preview-tooltip {
          & /deep/ .arrow bottom center{
            display: none;
          }
        }
      }
    }
    .back-btn-wrap {
      & /deep/ button {
        min-width: initial;
        padding-right: 30px;
        padding-left: 12px;

        & .text {
          margin-left: 6px;
          padding-left: 16px;
        }
      }

      .back-btn {
        & /deep/ .icon {
          left: 15px;
        }
      }

      &.prev {
        &::after {
          content: "";
          position: absolute;
          display: block;
          bottom: 8px;
          right: 210px;
          width: 1px;
          height: 24px;
          background-color: #a5a3a3;
        }
      }
    }
    .back-btn-wrap-edit {
      .back-btn {
        & /deep/ .icon {
          left: 15px;
        }
      }

      &.prev {
        &::after {
          content: "";
          position: absolute;
          display: block;
          bottom: 8px;
          right: 210px;
          width: 1px;
          height: 24px;
          background-color: #a5a3a3;
        }
      }
    }
  }
}
</style>
